export const PRODUCTS = [
    { name: "PREMIUM BABY GIFT PAPER BAGS", hsn: "4819", gst: 5 },
    { name: "Premium Teddy Bear Paper Bags", hsn: "4819", gst: 5 },
    { name: "Animal-Themed Premium Gift Paper Bags", hsn: "4819", gst: 5 },
    { name: "Vibrant Cartoon & Floral Kids Bags", hsn: "4202", gst: 18 },
    { name: "Premium Metallic Finish Paper Gift Bags", hsn: "4819", gst: 5 },
    { name: "Premium Glitter Paper Bag", hsn: "4819", gst: 5 },
    { name: "3D Space Theme Zipper Pouch Bags (Plastic)", hsn: "3926", gst: 18 },
    { name: "Cute Paw-Shaped Silicone Pencil Box", hsn: "3926", gst: 18 },
    { name: "Pop-It Cover Spiral Notebook", hsn: "4820", gst: 0 },
    { name: "Cute Kids' Stationery Gift Set (6-in-1 Combo)", hsn: "9609", gst: 0 },
    { name: "Kids' Space Theme Writing Set (Stationery Pack)", hsn: "9609", gst: 0 },
    { name: "Premium Birthday Gift Bags", hsn: "4819", gst: 5 },
    { name: "Cute Animal Cartoon Mini Backpacks for Kids (Plush & PU)", hsn: "4202", gst: 18 },
    { name: "Space Adventure 3D Pencil Case (EVA Hardtop)", hsn: "9608", gst: 18 },
    { name: "Premium Quality Mini LED Desk Lamp", hsn: "9405", gst: 18 },
    { name: "Premium Bear-Themed Paper Gift Bags", hsn: "4819", gst: 5 },
    { name: "Fantasy-Themed Premium Paper Gift Bags", hsn: "4819", gst: 5 },
    { name: "Premium Celebration Gift Paper Bag", hsn: "4819", gst: 5 },
    { name: "Cute Cartoon Pencil Case for Kids (PU Leather)", hsn: "4202", gst: 18 },
    { name: "Pop It Fidget Cube (Silicone)", hsn: "3926", gst: 18 },
    { name: "Water Bottle 460-500 ml (Plastic)", hsn: "3923", gst: 18 },
    { name: "\"Just Love\" Vacuum Insulated Bottle -380 ml (Stainless Steel)", hsn: "9617", gst: 18 },
    { name: "Fruit Infuser Water Bottle 1000ML (Plastic)", hsn: "3923", gst: 18 },
    { name: "Water Bottle (Bold Design, Plastic)", hsn: "3923", gst: 18 },
    { name: "Airtight Fridge Storage Box (Plastic)", hsn: "3924", gst: 18 },
    { name: "550ML Shaker Water Bottle (Plastic)", hsn: "3923", gst: 18 },
    { name: "Airtight Fresh Box (Compact Food Storage, Plastic)", hsn: "3924", gst: 18 },
    { name: "Combined Refrigerator Box (Plastic)", hsn: "3924", gst: 18 },
    { name: "Kids Water Bottle 460ML (Plastic, with Straw & Strap)", hsn: "3923", gst: 18 },
    { name: "Refillable Dispenser Bottle (Plastic with Pump)", hsn: "3923", gst: 18 },
    { name: "Bunny Fruit Fork Set with Two Stands (Plastic)", hsn: "3924", gst: 18 },
    { name: "Carrot-Shaped Spoon (Plastic)", hsn: "3924", gst: 18 },
    { name: "Travel Soap Case (Plastic)", hsn: "3924", gst: 18 },
    { name: "Silicone Oil & Basting Brush (Silicone with SS handle)", hsn: "3924", gst: 18 },
    { name: "Silicone Spatula (Silicone with SS handle)", hsn: "3924", gst: 18 },
    { name: "Stainless Steel Pizza Cutter", hsn: "8215", gst: 18 },
    { name: "Stainless Steel Fine Mesh Stainer", hsn: "7323", gst: 18 },
    { name: "Rainbow Color Plastic Storage Container Set", hsn: "3924", gst: 18 },
    { name: "Premium Shovel Design for Easy Fruit Scooping (SS Holo Spoon)", hsn: "8215", gst: 18 },
    { name: "Multifunctional Stainless Steel Spoon (Serrated)", hsn: "8215", gst: 18 },
    { name: "Stainless Steel Holo Spoon", hsn: "8215", gst: 18 },
    { name: "Rose Gold Stainless Steel Fork Set", hsn: "8215", gst: 18 },
    { name: "Seamless Double Soap Box Holder (Wall-Mounted)", hsn: "3924", gst: 18 },
    { name: "Compact Toothbrush Holder (Plastic)", hsn: "3924", gst: 18 },
    { name: "Set of 4 Anti-Vibration & Anti-Slip Pads (for Washing Machines)", hsn: "3926", gst: 18 },
    { name: "Gradient Tumbler with Straw (Plastic)", hsn: "3924", gst: 18 },
    { name: "Ice Ball Maker (Silicone Mold)", hsn: "3924", gst: 18 },
    { name: "Transparent Water Bottle (Plastic)", hsn: "3923", gst: 18 },
    { name: "Arc-Shaped Garlic Press (Hand Tool)", hsn: "8215", gst: 18 }
];
